/*
 * Detects if IE version < 11 and displays a notification with a button that redirects
 * to a resource where user can update from.
 */

(function () {

  var notificationMsg = document.getElementById("notify-old-browser");
  var closeNotificationBtn = document.getElementById("closeNotificationBtn");

  function isIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE');
    return (msie > 0) ? parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10) : false;
  }

  if (isIE() && isIE() < 11) {
    notificationMsg.style.display = 'block';
  }

  // close notification
  closeNotificationBtn.onmousedown = function () {
    notificationMsg.style.display = 'none';
    return false;
  };

}());